import React, {FC} from "react";
import {DailyTransactionTypeEnum, PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";
import {searchPurchaseTransactionsReport} from "../../../serviceBroker/transationReportApiServiceBroker";

export const ReportPurchaseTransactions: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
        transactionType:DailyTransactionTypeEnum.PurchasesInvoice
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchPurchaseTransactionsReport}
            searchHeader={getPageNameByPageId(PageEnum.ReportPurchases)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.ReportPurchases}
        />
    );
};
